/**
 * Product Image Magnifier - Lightweight Version
 * Minimal code, maximum performance
 */
(function() {
  'use strict';
  
  function waitForJQuery() {
    if (typeof jQuery === 'undefined') {
      setTimeout(waitForJQuery, 50);
      return;
    }
    init(jQuery);
  }
  
  waitForJQuery();
  
  function init($) {
    var enabled = false;
    var glass = null;

    function hasMousePointer() {
      if (window.matchMedia) {
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      }

      return !('ontouchstart' in window);
    }

    // Create magnifier
    function magnify(img, zoom) {
      if (!img || !img.src || img.src.includes('gtm') || img.src.includes('tracking')) return;
      
      glass = document.createElement("DIV");
      glass.className = "img-magnifier-glass";
      img.parentElement.insertBefore(glass, img);
      
      var masterUrl = img.dataset.master || img.src;
      glass.style.backgroundImage = "url('" + masterUrl + "')";
      glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
      
      var bw = 3, w = glass.offsetWidth / 2, h = glass.offsetHeight / 2;
      
      function move(e) {
        e.preventDefault();
        var rect = img.getBoundingClientRect();
        var x = e.pageX - rect.left - window.pageXOffset;
        var y = e.pageY - rect.top - window.pageYOffset;
        
        if (x > img.width - (w / zoom)) x = img.width - (w / zoom);
        if (x < w / zoom) x = w / zoom;
        if (y > img.height - (h / zoom)) y = img.height - (h / zoom);
        if (y < h / zoom) y = h / zoom;
        
        glass.style.left = (x - w) + "px";
        glass.style.top = (y - h) + "px";
        glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
      }
      
      glass.addEventListener("mousemove", move);
      img.addEventListener("mousemove", move);
      img.addEventListener("mouseleave", function() { glass.style.opacity = "0"; });
      img.addEventListener("mouseenter", function() { glass.style.opacity = "1"; });
    }

    // Initialize
    function startMagnifier() {
      if (!hasMousePointer() || !enabled) return;
      
      $('.img-magnifier-glass').remove();
      
      var $img = $('#sync1 .owl-item.active .product-main-image').first();
      if (!$img.length) $img = $('#sync1 .product-main-image').first();
      
      if ($img.length && $img[0].complete) {
        magnify($img[0], 3);
      } else if ($img.length) {
        // If image not loaded yet, wait for it
        $img.on('load', function() {
          magnify(this, 3);
        });
      }
    }

    // Toggle
    function toggle(e) {
      e.preventDefault();
      e.stopPropagation();
      
      enabled = !enabled;
      $(this).toggleClass('active').attr('data-magnifier-active', enabled);
      
      if (enabled) {
        startMagnifier();
      } else {
        $('.img-magnifier-glass').remove();
      }
    }

    // Bind events - Optimized with minimal delay
    $(document).ready(function() {
      setTimeout(function() {
        $(document).on('click', '.magnifier-toggle', toggle);
        $('#sync1').on('changed.owl.carousel', function() {
          if (enabled) {
            // Immediate response on carousel change
            setTimeout(startMagnifier, 50);
          }
        });
      }, 100);
    });
  }
})();
